import { axios } from '../main';

export default class TransactionsResource {
    async getFilteredTransactionsWithPagination(query, currentPage) {
        let limit = 25;
        return await axios.get(
            process.env.VUE_APP_REST_API + `transactions?page=${currentPage}&limit=${limit}${query}`
        )
    }
    async getTotalAmount(query) {
        return await axios.get(
            process.env.VUE_APP_REST_API + `transactions/total-amount?${query}`
        )
    }

    async getFilteredTransactionsWithLimit(query, limit, page) {
        return await axios.get(
            process.env.VUE_APP_REST_API + `transactions?page=${page}&limit=${limit}${query}`
        )
    }
}
